import { Box, Button, Paper, Typography } from '@mui/material';

export function UseNewPasswordView() {
  return (
    <Box
      sx={{
        height: '100vh',
        bgcolor: 'grey.100',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: { xs: 4, sm: 8 },
      }}
    >
      <Paper
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
          maxWidth: '430px',
          width: '100%',
          mt: { xs: 5, sm: 10 },
          mx: { xs: 2, sm: 0 },
        }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          ¡Ya puedes iniciar sesión!
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Ya puedes utilizar tu nueva contraseña
        </Typography>
        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
          onClick={() => (window.location.href = '/seller/login')}
        >
          Iniciar sesión
        </Button>
      </Paper>
    </Box>
  );
}
